"use client";
import React from "react";
import CustomerDetails from "../../../global/view/customer-detailsForm"; 
import { useNavigate } from "react-router-dom";

export default function OTCCustomerDetails() {
  const navigate = useNavigate();
  return (
    <CustomerDetails
      actionButtonLabel="View"
      showAddPatientButton={true}
      backTo="/customer/dispensary"
      onActionClick={(profileNo) =>
        navigate(`/customer/dispensary/otc-direct/dispense-table`, {
          state: { profileNo },
        })
      }
    />
  );
}